import React from "react";
import dynamic from "next/dynamic";
import { LayoutMain } from "@unisearch/theme/layout";
import CarouselSkeleton from "./skeleton/carousel_skeleton";
import RecentVideoSkeleton from "./skeleton/recent_video_skeleton";
import CategoryCarouselSkeleton from "@modules/skeleton/category_carousel";

const VlogHeroCarousel = dynamic(
  () => import("@modules/study/vlog/components/hero_carousel"),
  {
    ssr: false,
    loading: () => <CarouselSkeleton />,
  }
);
const VlogRecentVideos = dynamic(() => import("@modules/study/vlog/vlog"), {
  ssr: false,
  loading: () => (
    <div className="container">
      <RecentVideoSkeleton />
    </div>
  ),
});
const VlogCategoryCarousel = dynamic(
  () => import("@modules/study/vlog/components/category_carousel"),
  {
    ssr: false,
    loading: () => (
      <div className="container" style={{ marginTop: "50px" }}>
        <CategoryCarouselSkeleton />
      </div>
    ),
  }
);
const VlogPlaylist = dynamic(
  () => import("@modules/study/vlog/components/playlist"),
  {
    ssr: false,
  }
);
const VlogTaglist = dynamic(
  () => import("@modules/study/vlog/components/taglist"),
  {
    ssr: false,
  }
);

const Vlog = () => {
  return (
    <LayoutMain
      title={"Vlog"}
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/vlog`}
    >
      <VlogHeroCarousel />
      <VlogRecentVideos limit={8} />
      <VlogCategoryCarousel />
      <VlogPlaylist />
      <VlogTaglist />
    </LayoutMain>
  );
};

export default Vlog;
